import { Controller } from "stimulus"

// Post-donation "quick questions" survey on the thank-you page, drawn from the client's post_checkout
// donor questions. Every named field is a custom_donor_info key; nothing on the page depends on this data persisting.
export default class extends Controller {
  static targets = ["form", "other", "thanks", "error", "submitButton"]

  static values = {
    submitUrl: String,
    // Which checkout this survey belongs to (DonationFlowsController#offer_post_checkout_survey!).
    token: String,
    // Which thank-you card this is (Client::DonorQuestion#section). Blank is the single HLI card.
    section: String
  }

  // A question with other_option reveals its "Please specify" field (named "<question>_other") when "other" is chosen.
  toggleOther(event) {
    const questionName = event.currentTarget.name
    const chosenOther = event.currentTarget.value === "other"

    this.otherTargets
      .filter((input) => input.dataset.surveyOtherFor === questionName)
      .forEach((input) => {
        input.classList.toggle("is-hidden", !chosenOther)
        input.required = chosenOther
        if (!chosenOther) input.value = ""
      })
  }

  // Only thanks the donor once the answers are actually saved; any failure keeps the form so they can retry.
  async submit(event) {
    event.preventDefault()

    const responses = {}
    new FormData(this.formTarget).forEach((value, key) => {
      const trimmed = value.trim()
      if (trimmed) responses[key] = trimmed
    })

    this.errorTarget.classList.add("is-hidden")
    this.submitButtonTarget.disabled = true

    try {
      const response = await fetch(this.submitUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ survey: this.tokenValue, section: this.sectionValue, responses })
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      this.formTarget.classList.add("is-hidden")
      this.thanksTarget.classList.remove("is-hidden")
    } catch (error) {
      console.error("Survey submit failed:", error)
      this.errorTarget.classList.remove("is-hidden")
      this.submitButtonTarget.disabled = false
    }
  }
}
